export const getPaymentHistoryUrl = (customerId, contractNumber) =>
  `paymentHistory?contractNumber=
${contractNumber}&customerId=${customerId}`;

export const convertAmountToInt = (stringAmount) => {
  return stringAmount.replace(/,/g, '');
};
